<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0">Kunden</h3>
                </div>
                <div class="col">
                </div>
                <div class="col text-right">
                    <el-input
                        type="search"
                        class=""
                        clearable
                        prefix-icon="el-icon-search"
                        style="width: 300px"
                        placeholder="Suche"
                        v-model="search"
                        aria-controls="datatables"
                    >
                    </el-input>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <el-table @row-click="getCustomer"
                      type="index"
                      ref="customersTable"
                      class="table-responsive clickableRow"
                      :class="type === 'dark' ? 'table-dark': ''"
                      :header-row-class-name="type === 'dark' ? 'thead-dark': ''"
                      :default-sort="{ prop: 'lastName', order: 'ascending' }"
                      empty-text="Keine Einträge vorhanden"
                      @sort-change="changeSort"
                      :data="filteredCustomers">
                <el-table-column prop="lastName" label="Nachname" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']">
                    <template v-slot="{ row }">
                        {{ (row.firstName) ? row.lastName + ' ' + row.firstName : row.lastName }}
                    </template>
                </el-table-column>
                <el-table-column prop="addressType" label="Adresstyp" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']">
                    <template v-slot="{ row }">
                        {{ (row.addressType) ? row.addressType : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="zip" label="Postleitzahl" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']">
                    <template v-slot="{ row }">
                        {{ (row.zip) ? row.zip : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="city" label="Ort" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']">
                    <template v-slot="{ row }">
                        {{ (row.city) ? row.city : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="buttons" label="Aktionen" min-width="170px">
                    <template v-slot="{ row }">
                        <base-button title="Kunden simulieren" size="sm"
                                     @click.stop="simulateUser(row.id)" type="warning"><i class="fad fa-walking"></i>
                        </base-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="card-footer d-flex justify-content-end"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <base-pagination v-model="pagination" :total="total" :perPage="perPage"></base-pagination>
        </div>
        <base-alert v-if="error.length > 0" type="danger">
            <span class="alert-inner--text"><strong>Fehler!</strong>  {{ error }}</span>
        </base-alert>
    </div>
</template>
<script>
import moment from 'moment';
import UserService from '@/services/user.service';
import BaseAlert from "@/components/BaseAlert";
import {
    ElTable,
    ElTableColumn,
    ElDropdownMenu,
    ElDropdownItem,
    ElDropdown,
    ElInput,
    ElSelect,
    ElOption
} from "element-plus";

export default {
    name: 'customers-table',
    components: {
        BaseAlert,
        [ElTable.name]: ElTable,
        [ElTableColumn.name]: ElTableColumn,
        [ElDropdown.name]: ElDropdown,
        [ElDropdownItem.name]: ElDropdownItem,
        [ElDropdownMenu.name]: ElDropdownMenu,
        [ElInput.name]: ElInput,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
    },
    props: {
        type: {
            type: String
        },
        title: String
    },
    computed: {
        clientId: {
            get: function () {
                return this.$store.state.auth.user.clientId;
            },
            set: function (value) {
                this.$store.commit('auth/setClientId', value);
            }
        },
        filteredCustomers() {
            if (this.search === '') {
                this.total = this.customers.length;
                return this.customers.filter((item,idx) => (idx >= this.start && idx < this.start + this.perPage));
            } else {
                const entries = this.customers.filter(item => {
                    let props = Object.values(item);
                    return props.some(prop => !this.search.toLowerCase() || ((typeof prop === 'string') ? prop.toLowerCase().includes(this.search.toLowerCase()) : prop.toString(10).toLowerCase().includes(this.search.toLowerCase())))
                });
                this.total = entries.length;
                return entries.filter((item,idx) => (idx >= this.start && idx < this.start + this.perPage));
            }
        },
    },
    methods: {
        changeSort(sort) {
            this.currentSort = (!sort.prop) ? '' : sort.prop;
            this.currentSortDir = (!sort.order) ? '' : sort.order;
            this.sortTable();
        },
        sortTable() {
            this.customers.sort((a, b) => {
                let modifier = 1;
                if (this.currentSortDir === 'descending') modifier = -1;
                if (a[this.currentSort].toLowerCase() < b[this.currentSort].toLowerCase()) return -1 * modifier;
                if (a[this.currentSort].toLowerCase() > b[this.currentSort].toLowerCase()) return modifier;
                return 0;
            });
        },
        convertDate(date) {
            return moment(date).format('DD.MM.YYYY HH:mm');
        },
        simulateUser(id) {
            UserService.simulateClientId(id).then(
                response => {
                    this.clientId = response.data.clientId;
                    window.location.reload();
                },
                error => {
                    this.getError(error);
                }
            );
        },
        getError(error) {
            if (error.response && error.response.status == '401') {
                this.error = 'you are not logged in!';
            } else if (error.response && error.response.status == '403') {
                this.error = 'you are not permitted!';
            } else {
                this.error =
                    (error.response && error.response.data) ||
                    error.message ||
                    error.toString();
            }
        },
        getCustomers() {
            UserService.getCustomers().then(
                response => {
                    this.customers = response.data.data;
                    this.sortTable(this.currentSort);
                    this.total = response.data.recordsTotal;
                    this.error = '';
                    this.disabled = false;
                    this.$emit("changed", response.data);
                },
                error => {
                    this.getError(error);
                }
            );
        },
        getCustomer(data) {
            this.$router.push('/customers/' + data.id);
        },
    },
    created() {
        this.getCustomers();
    },
    data() {
        return {
            pagination: 1,
            total: 0,
            start: 0,
            customers: [],
            currentSort: 'lastName',
            currentSortDir: 'asc',
            search: '',
            disabled: true,
            error: '',
            newRequest: '',
            errorText: '',
            perPage: 10
        }
    },
    watch: {
        pagination(){
            this.start = (this.pagination - 1) * this.perPage;
        }
    }
}
</script>
<style scoped lang="scss">
:root {
    --ck-border-radius: 0.375rem;
}

.errorText {
    color: #f5365c;
}

thead th {
    cursor: pointer;
}
.el-input__inner {
    border-color: #444444!important;
}
</style>
